
<div class="btn-group">
  <button class="btn btn-sm btn-outline-primary" (click)="edit()" *ngIf="!item.editing"><span class="oi oi-pencil"></span></button>
  <button class="btn btn-sm btn-outline-primary" (click)="save()" *ngIf="item.editing"><span class="oi oi-check"></span></button>
  <button class="btn btn-sm btn-outline-danger" (click)="remove()"><span class="oi oi-trash"></span></button>
</div>